import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { airPriceWatchGetListQuery } from './priceWatchQueries'
import { getGraphURL } from '@mfs/client/utils/getServiceUrl'
import { APOLLO_CLIENT_NAME } from '@mfs/client/common/constants/constants'

const requestPriceWatchGetList = async ({
  departDate,
  destCityId,
  email,
  originCityId,
  returnDate,
  destCityCode,
  originCityCode,
  useLocalFlyql = false,
}) => {
  const operationName = 'airPriceWatchGetListResponse'
  try {
    const priceWatchGetListResponse = await axios({
      url: getGraphURL({ operationName, useLocalFlyql }),
      method: 'post',
      headers: {
        'apollographql-client-name': APOLLO_CLIENT_NAME,
        'apollographql-client-version': globalThis.PCLN_BOOTSTRAP_DATA?.appVersion || 'development',
      },
      data: {
        operationName,
        variables: {
          input: {
            email,
            originCityId,
            originCityCode,
            destCityId,
            destCityCode,
            departDate,
            returnDate,
            requestId: uuidv4(),
            includeOptedOut: false,
            includeInactive: false,
          },
        },
        query: airPriceWatchGetListQuery,
      },
    })
    return priceWatchGetListResponse?.data?.data?.airPriceWatchGetListResponse
  } catch (err) {
    return {
      status: 'ERROR',
      err: err,
    }
  }
}

export { requestPriceWatchGetList }
